import { Location } from '@angular/common'
import { ActivatedRoute } from '@angular/router'
import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core'
import { NgOptimizedImage } from '@angular/common'

import { PAGE_MAPPING } from './error-page.constants'
import { Button } from '@shared/components/button/button'
import { TranslatePipe } from '@ngx-translate/core'

@Component({
  selector: 'bo-error-page',
  templateUrl: './error-page.html',
  styleUrls: ['./error-page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Button, TranslatePipe, NgOptimizedImage],
})
export class ErrorPage implements OnInit {
  readonly #location = inject(Location)
  readonly #activatedRoute = inject(ActivatedRoute)

  public titleInfo: { title: string; subTitle: string }

  ngOnInit() {
    this.titleInfo =
      (this.#activatedRoute.routeConfig.path != null
        ? PAGE_MAPPING[this.#activatedRoute.routeConfig.path]
        : null) || PAGE_MAPPING['default']
  }

  navigateBack() {
    this.#location.back()
  }
}
